import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ConfigurationReducer } from './store/configuration.reducer';
import { ConfigurationService } from './services/configuration.service';
import { ConfigurationStoreHandler } from './services/configuration-store-handler.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('configuration', ConfigurationReducer)
  ],
  declarations: []
})
export class ConfigurationModule {
  public static forRoot() {
    return {
      ngModule: ConfigurationModule,
      providers: [ConfigurationService, ConfigurationStoreHandler]
    };
  }


}
